var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessIco1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.251,
    height: 128.251,
    viewBox: "0 0 128.251 128.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-446.17 -2857.179)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.343,
    cy: 45.343,
    r: 45.343,
    transform: "translate(446.17 2921.305) rotate(-45)",
    fill: "#f23674"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(478.803 2892.69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.725,99.772H50.969a2.585,2.585,0,0,1-2.585-2.585V84.26H41.919A1.295,1.295,0,0,1,41,82.051L53.931,69.124a1.3,1.3,0,0,1,1.828,0L68.686,82.051a1.295,1.295,0,0,1-.914,2.209H61.311V97.187A2.59,2.59,0,0,1,58.725,99.772Zm-13.688-18.1h4.637a1.3,1.3,0,0,1,1.295,1.295V97.187h7.756V82.97a1.291,1.291,0,0,1,1.291-1.295h4.637l-9.808-9.808Z",
    transform: "translate(-23.758 -42.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.547,47.534a.923.923,0,0,1-.149,0,12.923,12.923,0,0,1,.55-25.746A19.372,19.372,0,0,1,48.135,16.7,15.483,15.483,0,0,1,50.671,47a1.291,1.291,0,0,1-.691-2.482,12.894,12.894,0,0,0-2.751-25.283,1.3,1.3,0,0,1-1.1-.745,16.786,16.786,0,0,0-31.806,4.745,1.291,1.291,0,0,1-1.278,1.113,10.341,10.341,0,0,0-1.357,20.613,1.291,1.291,0,1,1-.141,2.577Z",
    transform: "translate(0.152 -6.244)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessIco1);
export default __webpack_public_path__ + "static/media/process_ico_1.f57162ec912aedbaee8eacb6217150f4.svg";
export { ForwardRef as ReactComponent };